import { fix, parse } from "postcode";

export const formatPostalCode = (
  postalCode: string,
  country: "GB" | string,
): { valid: true; postalCode: string } | { valid: false; postalCode: null } => {
  if (country !== "GB") {
    return { valid: true, postalCode };
  }

  const { valid, postcode } = parse(fix(postalCode));

  if (!valid) {
    return {
      valid: false,
      postalCode: null,
    };
  }

  return {
    valid: true,
    postalCode: postcode,
  };
};
